import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'
import Setting from './Setting/index'
import Custom from './custom'
import Auth from '../modules/auth-service/auth/store'
import Portal from '../modules/portal/store'
import Complain from '../modules/common-config/complain/store'
import Notification from '../modules/common-config/notification/store'
import ExternalUser from '../modules/external-user-service/store'
import Document from '../modules/common-config/document/store'
import Committee from '../modules/common-config/committee/store'
import ProductionService from '../modules/production-service/store'
import HospitalDisabilityService from '../modules/hospital-disability-service/store'
import ChildService from '../modules/child-service/store'
import GrantAllowanceService from '../modules/grant-allowance-service/store'
import AwarenessEventService from '../modules/awareness-event-service/store'
import DisabilitySchoolService from '../modules/disability-school-service/store'
import TrainingElearning from '../modules/training-e-learning-service/store'
import SocialWelfareService from '../modules/social-welfare-service/store'
import streetChildrenService from '../modules/street-children-service/store'
import rehabilitationVagrantService from '../modules/rehabilitation-vagrant-service/store'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    Setting,
    Portal,
    Auth,
    Complain,
    Notification,
    ExternalUser,
    Document,
    Committee,
    ProductionService,
    HospitalDisabilityService,
    ChildService,
    GrantAllowanceService,
    AwarenessEventService,
    TrainingElearning,
    DisabilitySchoolService,
    streetChildrenService,
    rehabilitationVagrantService,
    SocialWelfareService
  },
  state: {
    currentFiscalYearId: 0,
    list: [],
    notificationList: [],
    totalNotification: 0,
    isPushNotification: [],
    toggleNotification: false,
    emitNotification: false,
    commonObj: {
      hasDropdownLoaded: false,
      perPage: 10,
      dateFormat: 'DD/MM/YYYY',
      fiscaleYear: 'YYYY-YYYY',
      timeFormat: 'h:m',
      unitOfTime: 'minute',
      loading: false,
      listReload: false,
      countryList: [],
      divisionList: [],
      districtList: [],
      upazilaList: [],
      unionList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      zoneList: [],
      wardList: [],
      organizationProfileList: [],
      officeTypeList: [],
      noticeforList: Custom.noticeForList,
      archiveCurrentList: Custom.archiveCurrentList,
      comStatusList: Custom.statusList,
      maritalStatus: Custom.maritalStatus,
      genderList: Custom.genderList,
      subOccupationList: Custom.subOccupationList,
      facilityList: Custom.facilityList,
      bloodGroupList: Custom.bloodGroupList,
      instituteType: Custom.instituteTypeList,
      beneficiaryAccountType: Custom.beneficiaryAccountType,
      bankAccountType: Custom.bankAccountType,
      mfsService: Custom.mfsService,
      applicationTypeList: Custom.applicationTypeList,
      answerList: Custom.answerList,
      modeList: Custom.modeList,
      officeList: [],
      designationList: [],
      subDesignationList: [],
      gradeList: [],
      notifications: [],
      fiscalYearList: [],
      instituteTypeList: [],
      wardTypeList: Custom.wardTypeList,
      patientTypeList: Custom.patientTypeList,
      portalServiceCategoryList: [],
      portalServiceCustomerTypeList: [],
      religionList: Custom.religionList,
      eventTypeList: [],
      stallTypeList: [],
      disabilityTypesList: [],
      assistiveDeviceList: [],
      ccList: [],
      hpcList: [],
      rxList: [],
      dhList: [],
      oeList: [],
      pmhList: [],
      adviceList: [],
      diagnosisList: [],
      monthList: Custom.monthList,
      messageTemplateList: []
    },
    commonObjCommonConfig: {
      hasDropdownLoaded: false,
      componentList: [],
      reportTypes: Custom.reportTypes,
      formTypes: Custom.formTypes,
      moduleList: [],
      serviceList: [],
      serviceComList: [],
      menuList: [],
      notificationTypeList: [],
      cmtCommitteeList: [],
      cmtAgendaList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      documentCategoryList: [],
      branchList: [],
      wardList: [],
      serviceEligibiltyList: [],
      buttonTypeList: Custom.buttonTypeList,
      mediaList: Custom.mediaList,
      recipientList: Custom.recipientList
    },
    orgList: [],
    orgComponentList: [],
    dataFilters: {
      orgId: 0,
      officeTypeId: 0,
      officeId: 0
    }
  },
  actions,
  mutations,
  getters,
  plugins: [createPersistedState()],
  strict: debug
})
